// extracted by mini-css-extract-plugin
export var container = "SocialShare-module--container--f8203";
export var socialIcon = "SocialShare-module--socialIcon--8557b";